import moment from 'moment';

import vector1 from 'src/images/Vector-1.svg'
import vector2 from 'src/images/Vector-2.svg'
import vector3 from 'src/images/Vector-3.svg'
import vector4 from 'src/images/Vector-4.svg'
import vector5 from 'src/images/Vector-5.svg'
import vector6 from 'src/images/Vector-6.svg'
import vector7 from 'src/images/Vector-7.svg'
import vector8 from 'src/images/Vector-8.svg'
import vector14 from 'src/images/Vector-14.svg'
import vector15 from 'src/images/Vector-15.svg'
import vector16 from 'src/images/Vector-16.svg'
import vector17 from 'src/images/Vector-17.svg'
import vector18 from 'src/images/Vector-18.svg'

import survey from 'src/images/survey.svg'
import crowdsource from 'src/images/crowdsource.svg'
import prioritize from 'src/images/prioritize.svg'

const getEventEndDate = (a) => a.end_on
  ? moment(a.end_on)
  : moment.unix(a?.schedule?.voting?.end_time)

const twoWeeksAgo = moment().subtract(2, 'weeks')
const now = moment()

// Filters 
const lambda = a => a
// Session type
const recentLambda = a => getEventEndDate(a).isAfter(twoWeeksAgo)
const activeLambda = a => getEventEndDate(a).isAfter(now)
const completedLambda = a => getEventEndDate(a).isBefore(now)
// Show
const prioritizeLambda = a => a.collection_type
const crowdsourceLambda = a => !a.collection_type && a.collection?.type !== 'survey'
const surveyLambda = a => !a.collection_type && a.collection?.type === 'survey'
// Toggle
const createdLambda = a => a.user_created
const participatedLambda = a => !a.user_created

export const tabFilters = [
  {
    id: 'show', label: 'Show', options: [
      { id: 'all', text: 'All', value: 'All', lambda },
      { id: 'recent', text: 'Recent Activity', value: 'Recent Activity', lambda: recentLambda },
      { id: 'active', text: 'Active', value: 'Active', lambda: activeLambda },
      { id: 'completed', text: 'Completed', value: 'Completed', lambda: completedLambda },
    ]
  },
  {
    id: 'session', label: 'Session Type', options: [
      { id: 'all', text: 'All', value: 'All', lambda },
      { id: 'prioritize', text: 'Prioritize', value: 'Prioritize', lambda: prioritizeLambda },
      { id: 'crowdsource', text: 'Crowdsource', value: 'Crowdsource', lambda: crowdsourceLambda },
      { id: 'survey', text: 'Survey', value: 'Survey', lambda: surveyLambda },
    ]
  }
]

export const toggleTabs = [
  { id: 'created', className: 'left', text: 'POPins Created', lambda: createdLambda },
  { id: 'joined', className: 'right', text: 'POPins Joined', lambda: participatedLambda }
]

export const defaultFilters = {
  toggle: toggleTabs[0],
  [tabFilters[0].id]: tabFilters[0].options[1],
  [tabFilters[1].id]: tabFilters[1].options[0]
}


export const defaultSortFn = (a, b) => {
  const aa = a.end_on ? a.end_on : moment.unix(a.schedule?.voting?.end_time)
  const bb = b.end_on ? b.end_on : moment.unix(b.schedule?.voting?.end_time)
  return moment(bb).diff(aa, 'seconds')
}

export const introCards = [
  {
    id: 'prioritize',
    title: "Prioritize",
    icon: prioritize,
    text: "Collaborative Quantitative Decision Making for Teams",
    longText: 'Use our newest module to prioritize items for strategic planning, budgeting, backlogs, and more! Get quantitative results and collaborate with your team to make decisions faster.',
    abilities: [
      { icon: vector1, text: "Make data driven decisions and collaborate with stakeholders" },
      { icon: vector2, text: "Go deeper with Prioritize to make data driven decision with your team" },
      { icon: vector3, text: "POPin Prioritize is the new way to utilize crowdsourcing to help you make big decisions, faster." },
    ],
    usages: [
      { icon: vector4, text: "Budgeting" },
      { icon: vector5, text: "Strategic Planning" },
      { icon: vector6, text: "Project Prioritization" },
      { icon: vector7, text: "Product Innovation" },
      { icon: vector8, text: "Backlog" },    
    ]
  },
  {
    id: 'crowdsource',
    title: "Crowdsource",
    icon: crowdsource,
    text: "Collaborative Quantitative Tool for Any size team",
    longText: 'This is your traditional “Create a POPin” button you know and love. Use it to launch real-time collaboration around open-ended questions, ie: “What is one thing you’d like to address at our next Townhall?”',
    onClick: (history) => () => history.push('/r/crowdsource/create'),
    abilities: [
      { icon: vector14, text: "Pick a topic to crowdsource feedback from any size group" },
      { icon: vector15, text: "Group responds with thoughts, voting, and comments" },
      { icon: vector16, text: "Analyze reports with pre-sorted results on best answers/solutions" },
    ],
    usages: [
      { icon: vector5, text: "Team Alignment" },
      { icon: vector6, text: "Problem Solving" },
      { icon: vector7, text: "Innovation" },
      { icon: vector8, text: "Agenda Setting" },
    ]
  },
  {
    id: 'survey',
    title: "Survey",
    icon: survey,
    text: "Quantitative One to Many Standard Survey",
    longText: 'Use traditional survey-style questions (multiple choice, yes/no, stack ranking, 1-5 scale) plus collaborative comments.',
    onClick: (history) => () => history.push('/r/survey/create'),
    abilities: [
      { icon: vector17, text: "Pick from multiple choice, yes/no, and 5 star rating options to launch survey to audience" },
      { icon: vector18, text: "Analyze qualitative reports with survey results" },
    ],
    usages: [
      { icon: vector5, text: "Team Alignment" },
      { icon: vector6, text: "Problem Solving" },
      { icon: vector7, text: "Continuous Improvement" },
      { icon: vector8, text: "Agenda Setting" },
    ]
  }
]

export const TABS = [
  { id: 'Recent Activity', title: 'Recent Activity' },
  { id: 'Active', title: 'Active' },
  { id: 'Completed', title: 'Completed' },
  { id: 'Archived', title: 'Archived' }
]
